export default "__VITE_ASSET__oq7nfcTv__"